import request from '@/router/axios'

/**
 * AI对话
 */
export function aiChat(data) {
  return request({
    url: '/api/ai/chat',
    method: 'post',
    data
  })
}

/**
 * 检查AI服务状态
 */
export function checkAiStatus() {
  return request({
    url: '/api/ai/status',
    method: 'get'
  })
}
